import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { pink } from "@/pages/(app)/home/components/colors";
import useCountFilteredReturnRequests from "@babackapp/private-api-client/client/use-count-filtered-return-requests";
import useTranslation from "@babackapp/translations/use-translation";
import { CheckCircle } from "lucide-react";
import { useCallback, useEffect } from "react";
import { useReturnRequestsFilters } from "../../../providers/use-return-requests-filters";
import QuickFilterItem from "./quick-filter-item";

export default function ToBeTreatedQuickFilter() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();
  const { filters, clearAll, quickFilter, setQuickFilter } =
    useReturnRequestsFilters();

  const status = filters.get("status");
  const active = !status && quickFilter === "toBeTreated";

  const onClick = useCallback(() => {
    clearAll();
    setQuickFilter("toBeTreated");
  }, [filters]);

  const { data: results, refetch } = useCountFilteredReturnRequests({
    shopId: shop.id,
    filters,
    quickFilter: "toBeTreated",
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <QuickFilterItem
      count={results?.totalCount}
      active={active}
      title={t("returnRequestsQuickFilters.toBeTreated.title")}
      description={t("returnRequestsQuickFilters.toBeTreated.description")}
      icon={<CheckCircle className="size-3" color={pink} />}
      onClick={onClick}
    />
  );
}
